import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { HoldsCustomTextModel } from '../../models/custom_text_model';
import { HoldListQuery } from './../../queries/holds_list_query';

interface IHoldListModel {
  statusMessage: string;
  isLoading: boolean;
}

export class HoldsListContentController {
  private models: IHoldListModel;
  private customMessage: string = '';

  constructor(
    private $rootScope: ng.IRootScopeService,
    private ngHoldListQuery: HoldListQuery,
    private loadHoldsListCommand: ICommand,
    private loadHoldsCustomTextCommand: ICommand,
    private ngHoldsCustomTextModel: HoldsCustomTextModel
  ) {
    this.models = {
      statusMessage: 'Loading holds...',
      isLoading: false
    };
  }

  $onInit() {
    this.getCustomText();
  }

  getCustomText() {
    if (_4.isEmpty(this.ngHoldsCustomTextModel.read())) {
      this.loadHoldsCustomTextCommand().then(() => {
        this.setCustomText();
      });
    } else {
      this.setCustomText();
    }
  }

  setCustomText() {
    this.customMessage =
      _4.get(_4.find(this.ngHoldsCustomTextModel.read(), { nk: 'HOLD_ACTIVE_MESSAGE' }), 'text') || this.customMessage;
  }

  hasNeedsAttentionHolds(): boolean {
    return !_4.isEmpty(this.ngHoldListQuery.result.needsAttention);
  }

  hasRegularHolds(): boolean {
    return !_4.isEmpty(this.ngHoldListQuery.result.holds);
  }

  hasPastHolds(): boolean {
    return !_4.isEmpty(this.ngHoldListQuery.result.pastHolds);
  }

  hasHolds(): boolean {
    return this.hasNeedsAttentionHolds() || this.hasRegularHolds();
  }

  showAllClearText(): boolean {
    this.__updateLoader();
    return !this.hasNeedsAttentionHolds() && !this.hasRegularHolds() && !this.models.isLoading;
  }

  loadHolds() {
    if (this.models.isLoading) {
      return;
    }
    this.models.isLoading = true;
    this.loadHoldsListCommand().finally(() => this.__updateLoader());
  }

  private __updateLoader() {
    this.models.statusMessage = !this.ngHoldListQuery.hasHolds() ? 'Great, you have no holds!' : 'You have holds';
    this.models.isLoading = false;
  }
}

export class HoldsListContentComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-holds/src/components/holds_list_content/holds_list_content.html';
  public controller: any = HoldsListContentController;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/components/holds_list_content/holds_list_content_controller.ts